export const handleAndThrowForTimeouts = (error: unknown) => {
  if (error instanceof DOMException && error.name === 'AbortError') {
    throw error;
  }
};
